var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChurch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.964,
    height: 26.371,
    viewBox: "0 0 32.964 26.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M17.718,2.472h1.648a1.236,1.236,0,1,1,0,2.472H17.718V6.33l5.31,3.441a3.7,3.7,0,0,1,1.695,3.111V23.9h4.533a1.233,1.233,0,0,0,1.236-1.236v-3.6a1.308,1.308,0,0,0-.567-1.082l-3.554-2.256V12.779l4.9,3.173a3.7,3.7,0,0,1,1.695,3.111v3.6a3.706,3.706,0,0,1-3.708,3.708H3.708A3.707,3.707,0,0,1,0,22.663v-3.6a3.7,3.7,0,0,1,1.694-3.111l4.9-3.173v2.946L3.037,17.981a1.315,1.315,0,0,0-.565,1.082v3.6A1.235,1.235,0,0,0,3.708,23.9H8.241V12.882A3.7,3.7,0,0,1,9.936,9.771l5.31-3.441V4.945H13.6a1.236,1.236,0,1,1,0-2.472h1.648V1.236a1.236,1.236,0,1,1,2.472,0ZM16.482,8.478,11.234,11.8a1.4,1.4,0,0,0-.52,1.082V23.9h3.3V18.954a2.472,2.472,0,1,1,4.945,0V23.9h3.3V12.882a1.308,1.308,0,0,0-.567-1.082Z",
    fill: "#777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch);
export default __webpack_public_path__ + "static/media/church.371252011e902246a7b3213921791d3a.svg";
export { ForwardRef as ReactComponent };